// extracted by mini-css-extract-plugin
export default {"container":"Products_container__hB-7K","item":"Products_item__opjMo","selected":"Products_selected__RkVK-"};